import i18next from 'services/i18next';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.scss';
import { ErrorBoundary, LoadingIndicator } from 'components';
import { I18nextProvider } from 'react-i18next';
import { AppProvider } from 'context/AppContext';
import App from 'App';
import { LoadingProvider } from 'context/LoadingContext';
import { AuthProvider, DataProvider } from './context';

const rootElement = document.getElementById('root');
const root = createRoot(rootElement!);
root.render(
    <ErrorBoundary>
        { /* eslint-disable-next-line camelcase */ /* Ref:https://reactrouter.com/6.30.0/upgrading/future#v7_relativesplatpath */}
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <I18nextProvider i18n={i18next}>
                <AuthProvider>
                    <DataProvider>
                        <AppProvider>
                            <LoadingProvider>
                                <React.Suspense fallback={<LoadingIndicator isLoading />}>
                                    <App />
                                </React.Suspense>
                            </LoadingProvider>
                        </AppProvider>
                    </DataProvider>
                </AuthProvider>
            </I18nextProvider>
        </BrowserRouter>
    </ErrorBoundary>,
);
